<template>
    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg mt-1">
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.firstName.error_type)">
            <label class="text-xs mb-1">First Name</label>
            <input v-model="form.firstName.value" @keyup="validateFields(['firstName'])" placeholder="First Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.firstName.error_message" v-text="form.firstName.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.lastName.error_type)">
            <label class="text-xs mb-1">Last Name</label>
            <input v-model="form.lastName.value" @keyup="validateFields(['lastName'])" placeholder="Last Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.lastName.error_message" v-text="form.lastName.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.email.error_type)">
            <label class="text-xs mb-1">Email</label>
            <div class="relative">
              <input v-model="form.email.value" @keyup="validateFields(['email'])" @input="alphaNumericEmail" placeholder="Email" 
                :class="'placeholder-theme-878686 block rounded bg-gray-black w-full text-sm text-theme-white' + (item.status == 'active' ? ' border-theme-orange pr-[80px]' : ' border-none')" type="text">
              <span class="text-xs font-semibold absolute right-1 top-1 pt-2 px-1 bg-gray-black h-8" :class="item.emailVerificationStatus?'text-theme-green':'text-theme-orange'">{{item.emailVerificationStatus?'verified':'unverified'}}</span>
            </div>
            <p class="field-error label-text mt-1" v-if="form.email.error_message" v-text="form.email.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.phone.error_type)">
            <label class="text-xs mb-1">Phone Number</label>
            <div class="relative">
              <input v-model.number="form.phone.value" :onkeypress="preventNonNumbers" @keyup="validateFields(['phone'])" placeholder="Phone Number" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="number">
               <span class="text-xs font-semibold absolute right-1 top-1 pt-2 px-1 bg-gray-black h-8" :class="item.phoneVerificationStatus?'text-theme-green':'text-theme-orange'">{{item.phoneVerificationStatus?'verified':'unverified'}}</span>
            </div>
            <p class="field-error label-text mt-1" v-if="form.phone.error_message" v-text="form.phone.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper'">
            <label class="text-xs mb-1">Birthday</label>
            
            <div class=" bg-gray-black rounded w-full flex items-center">
              
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white" />
                </svg>
              </span>
              <Datepicker :inputFormat="'yyyy-MM-dd'" :startingViewDate="new Date(subtract18yr())" :upperLimit="new Date(subtract18yr())" v-model="form.dob" placeholder="Select a Date" class="text-sm focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full" /> 
            </div>

            <!-- <p class="text-xs mt-1 text-theme-orange">Date must be 18 year before</p> -->

          </div>
        </div>
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper relative ' + (form.primaryLocationId.error_type)">
            <label class="text-xs tracking-[0.4px]">Primary location</label>
            <select
              v-model="form.primaryLocationId"
              class="cursor-pointer w-full h-[35px] bg-[#464851] border-[#464851] focus:outline-0 focus:ring-0 focus:border-0 font-normal text-base leading-5 text-white p-2 rounded"
            >
              <option value="">Select</option>
              <option v-for="each in vg_locations" :key="each.id" :value="each.id">{{each.name}}</option>
            </select>
            <p class="field-error label-text mt-1" v-if="form.primaryLocationId.error_message" v-text="form.primaryLocationId.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div class="input-wrapper ">
            <label class="text-xs mb-1">Tax Exempt</label>
            <select-checkbox v-model="form.tax" :options="taxOptions" placeholder="Tax" class="block rounded bg-gray-black w-full border-none text-sm tracking-wider" :class="form.tax?.length?'text-white':'text-theme-878686'" />
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div class="input-wrapper ">
            <label class="text-xs mb-1">Status ID</label>
            <input v-model="form.idNumber" placeholder="Status ID" class="placeholder-theme-878686 block border-none focus:ring-0 focus:border-0 rounded bg-gray-black w-full text-sm text-theme-white" type="text">
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div class="flex flex-row  items-center input-wrapper mb-3 mt-3 mr-2">
            <label class="text-xs mb-1 mt-2 mr-2">Casl Opt-In</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" disabled :value="item.marketing" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (item.marketing ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase w-[30px]" :class="item.marketing ? 'text-theme-green' : 'text-[#F53333]'">{{item.marketing ? 'On' : 'Off'}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="bg-theme-borderblack h-1 w-full my-4"></div>
      <div class="w-full self-stretch inline-flex justify-start items-center gap-2">
        <div class="justify-start text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Address</div>
      </div>
      <div class="flex gap-3 xl:flex-row flex-col items-start my-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.address.error_type)">
            <label class="text-xs mb-1">Address</label>
            <input
              type="text"
              placeholder="Search Address"
              id="customer-address"
              @keyup="resetPlace"
              class="block border-none rounded bg-gray-black w-full text-sm text-white py-2 px-2 placeholder-theme-878686 focus:ring-transparent focus:outline-none"
            />
            <p class="field-error label-text mt-1" v-if="form.address.error_message" v-text="form.address.error_message"></p>
          </div>
        </div>
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.city.error_type)">
            <label class="text-xs mb-1">City</label>
            <input placeholder="Toronto" v-model="form.city.value" class="block border-none focus:ring-0 focus:border-0 rounded bg-gray-black w-full text-sm text-white placeholder-theme-878686" type="text">
            <p class="field-error label-text mt-1" v-if="form.city.error_message" v-text="form.city.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-5">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.province.error_type)">
            <label class="text-xs mb-1">Province</label>
            <input placeholder="Ontario" v-model="form.province.value" class="block border-none focus:ring-0 focus:border-0 rounded bg-gray-black w-full text-sm text-white placeholder-theme-878686" type="text">
            <p class="field-error label-text mt-1" v-if="form.province.error_message" v-text="form.province.error_message"></p>
          </div>
        </div>
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.postalCode.error_type)">
            <label class="text-xs mb-1">Postal Code</label>
            <input placeholder="L2C 1J1" v-model="form.postalCode.value" class="block border-none focus:ring-0 focus:border-0 rounded bg-gray-black w-full text-sm text-white placeholder-theme-878686" type="text">
            <p class="field-error label-text mt-1" v-if="form.postalCode.error_message" v-text="form.postalCode.error_message"></p>
          </div>
        </div>
      </div>

      <div class="bg-theme-borderblack h-1 w-full my-4"></div>
      <div class="flex gap-3 xl:flex-row flex-col items-start">
        <div class="w-full  self-stretch inline-flex justify-between items-center overflow-hidden">
          <div class="justify-start text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight">Membership</div>
          <div class="flex flex-row  items-center input-wrapper mb-3 mr-2">
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" v-model="form.membershipStatus" @change="changeMembershipWarning" true-value="active" false-value="blocked" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.membershipStatus === 'active' ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase w-[30px]" :class="form.membershipStatus === 'active' ? 'text-theme-green' : 'text-[#F53333]'">{{form.membershipStatus === 'active' ? 'On' : 'Off'}}</span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="item.loyaltyUserId && item.membershipStatus === 'active'">
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
          <div class="w-full xl:w-1/2">
            <div class="input-wrapper ">
              <label class="text-xs mb-1">Total Spent</label>
              <div class="relative">
                <input disabled v-model="form.totalOrderValue" placeholder="Total Spent" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
              </div>
            </div>
          </div>

          <div class="w-full xl:w-1/2">
            <div class="input-wrapper">
              <label class="text-xs mb-1">Member Since</label>
              <div class="relative">
                <input disabled :value="formatDate(form.memberSince)" placeholder="Date" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
              </div>
            </div>
          </div>
        </div>

        <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
          
            <div class="w-full xl:w-1/4">
              <div :class="'input-wrapper'">
                <label class="text-xs mb-1">Loyalty Points</label>
                <div class="block border-none rounded bg-gray-black w-full text-sm text-theme-white px-3 py-2">{{ form.points?form.points:0 }}</div>
              </div>
            </div>
            <div class="w-full xl:w-1/2 mb-4">
                <div :class="'input-wrapper ' + (pointAdjustment.points.error_type)">
                  <label class="text-xs mb-1">Point Adjustment</label>
                  <div class="block rounded bg-gray-black w-full relative">
                    <input :onkeypress="preventNonNumbers" @keyup="validateAdjustmentFormFields(['points'])" placeholder="Point Total" v-model.number="pointAdjustment.points.value"  class="placeholder-theme-878686 block border-none rounded bg-gray-black text-sm text-theme-white w-full pr-[60px]" type="number" />
                    <label class="flex items-center cursor-pointer absolute right-1 top-2">
                      <input type="checkbox" v-model="pointAdjustment.isAdditionalPoint" class="hidden peer">
                      <div :class="'relative toggle-bg label-inside-switch border-2  h-6 w-11 rounded-full ' + (pointAdjustment.isAdditionalPoint ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                        <span :class="'text-white ' + (pointAdjustment.isAdditionalPoint ? 'left-[3px] top-[1px] relative' : 'left-[21px] top-[1px] relative')"><mdicon v-if="pointAdjustment.isAdditionalPoint" size="16" name="plus" /> <mdicon v-if="!pointAdjustment.isAdditionalPoint" size="16" name="minus" /></span>
                      </div>
                    </label>
                  </div>
                  <p class="field-error label-text mt-1" v-if="pointAdjustment.points.error_message" v-text="pointAdjustment.points.error_message"></p>
                </div>
            </div>
            <div class="w-full xl:w-1/4">
              <button :disabled="!pointAdjustment.points.value || !can_edit_customer_details_in_admin" @click.prevent="adjustPoints()" class="disabled:cursor-default cursor-pointer mt-6 rounded-md bg-theme-green py-[6px] px-3 disabled:bg-theme-grey hover:bg-theme-darkgreen hover:text-white w-full">
                CONFIRM
              </button>
            </div>
        </div>
      </div>
      <div class="bg-theme-borderblack h-1 w-full my-4"></div>
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full">
          <div class="input-wrapper">
            <label class="text-xs mb-1">Notes</label>
            <div class="flex">
              <textarea v-model="form.notes" maxlength="200" placeholder="Write notes for the customer" class="border-none focus:ring-0 focus:border-0 block rounded bg-gray-black w-full text-sm"></textarea>
            </div>
            <p class="text-xs text-theme-878686 mt-1 text-right">{{ (form.notes || '').length }}/200</p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { defineComponent, ref} from "vue"
import {mapGetters,mapActions,mapMutations} from "vuex";
import { useSnackbar} from "vue3-snackbar";
import Datepicker from 'vue3-datepicker'
import Helpers from '@/helpers';
import LoyaltyPointsAdjustmentApis from '@/controllers/LoyaltyPointsAdjustmentApis';
import LoyaltyCustomerApis from '@/controllers/LoyaltyCustomerApis';
import UserCustomerApis from '@/controllers/UserCustomerApis';
import ProductApi from '@/controllers/BusinessProductApis';
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import moment from 'moment';
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";

export default defineComponent({
    name: "CustomerProfile",
    components: {
      Datepicker,
      ReturnConfirmModal,
      SelectCheckbox,
    },
    props: {
      clearComponent: {
        type: Function,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },
    setup() {
        const snackbar = useSnackbar();
        const pointAdjustment = ref({
          points: {
            value: '',
            error_type: '',
            error_message: '',
            validations: ['required'],
          },
          isAdditionalPoint: true,
      });
      const form = ref({
        firstName: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        lastName: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        email: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['email'],
        },
        phone: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['mustbe:10'],
        },
        dob: '',
        points: 0,
        totalOrderValue: null,
        memberSince: null,
        membershipStatus: 'active',
        idType: '',
        idNumber: '',
        tax: [],
        primaryLocationId: '',
        notes: '',
        address: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        city: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        province: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        postalCode: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
      })
      const taxOptions = ref([]);
      const deleteObj = ref({
        modal: false,
        obj: {},
      });
      const autocomplete = ref({});
      

      return {
        snackbar,
        form,
        pointAdjustment,
        taxOptions,
        deleteObj,
        autocomplete,
      };
    },
    computed: {
        can_edit_customer_details_in_admin() {
            return Helpers.getMyPermission('can_edit_customer_details_in_admin')
        },
        ...mapGetters({
        vg_locationSelected: "location/selected",
        vg_business: 'auth/activeBusiness',
        vg_locations: 'location/list',
      }),
    },
    watch: {
      'item'() {
        this.assignValues();
      },
    },
    async mounted() {
      await this.getTaxes();
      this.assignValues();
      this.initGoogle();
      this.emitter.on("update-customer-profile", this.update);
      this.emitter.on("remove-customer-profile", this.remove);
    },
    async beforeUnmount() {
      this.emitter.off('update-customer-profile', this.update);
      this.emitter.off('remove-customer-profile', this.remove);
    },
    methods: {
      formatDate(dateVal){
        if(!dateVal) return
        return moment(dateVal).format('YYYY-MM-DD')
      },
      subtract18yr() { 
        return moment().subtract('18', 'years').format('YYYY-MM-DD')
      },
      async getTaxes() {
        if (this.vg_business?.id) {
          let res = await ProductApi.fetchAllTaxes(this.vg_business.id);
          if (res.data?.payload) {
            this.taxOptions = res.data.payload.map(each => ({ id: each.id, name: each.name }));
          }
        }
      },
      async getCustomerTaxExempt() {
        let res = await LoyaltyCustomerApis.getCustomerTaxExempt(this.item.id);
        if (res.data?.payload) {
          this.form.tax = res.data.payload.map(each => each.id);
        }
      },
      async assignValues() {
        let data = await Helpers.assignFormValues(this.form, this.item);
        this.form = data
        this.form.firstName.value = this.item.firstName
        this.form.lastName.value = this.item.lastName
        this.form.memberSince = this.item.memberSince ? moment(this.item.memberSince).format('YYYY-MM-DD') : this.item.createdAt ? moment(this.item.createdAt).format('YYYY-MM-DD') : '';
        this.form.email.value = this.item.email
        this.form.dob = this.item.dob ? moment(this.item.dob).toDate() : '';
        this.form.phone.value = this.item.phone
        this.form.totalOrderValue = this.item.totalOrderValue
        this.form.membershipStatus = this.item.membershipStatus || 'blocked'
        this.form.primaryLocationId = this.item.primaryLocationRecord?.id || ''
        this.form.notes = this.item.notes || ''
        this.form.address.value = this.item.address || ''
        this.form.city.value = this.item.city || ''
        this.form.province.value = this.item.province || ''
        this.form.postalCode.value = this.item.postalCode || ''
        this.setAddressInput();
        this.getCustomerTaxExempt();
      },

      setAddressInput() {
        this.$nextTick(() => {
          const addressEl = document.getElementById('customer-address');
          if (addressEl) {
            addressEl.value = this.form.address.value || '';
          }
        });
      },

      initGoogle() {
        const self = this;
        setTimeout(async () => {
          let ele = document.getElementById("customer-address");
          if (!ele) return;
          this._gloader
            .load()
            .then((google) => {
              self.autocomplete = new google.maps.places.Autocomplete(ele, {
                componentRestrictions: { country: "ca" }
              });
              self.autocomplete.addListener('place_changed', self.setPlace)
            })
            .catch(e => {
              console.log(e)
            });
        }, 3000)
      },

      resetPlace() {
        let addressEl = document.getElementById('customer-address');
        this.form.address.value = addressEl?.value || '';
        if (!addressEl?.value) {
          this.form.postalCode.value = '';
          this.form.province.value = '';
          this.form.city.value = '';
          this.form.address.value = '';
        }
      },

      setPlace() {
        let addressData = this.autocomplete.getPlace();
        if (!addressData?.address_components) return;
        this.form.address.value = addressData.name;
        let addressEl = document.getElementById('customer-address');
        if (addressEl) {
          addressEl.value = addressData.name;
        }
        this.form.postalCode.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
        this.form.province.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1') ? Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1', 'short_name') : Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2', 'short_name');
        this.form.city.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'locality');
      },

      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },

      /**
       * Validate adjustent
       */
      async validateAdjustmentFormFields(fields) {
        let res = await Helpers.validateFormFields(this.pointAdjustment, fields);
        // capture the fields
        this.pointAdjustment = res.data;
        return res.error ? false : true;
      },

      changeMembershipWarning(){
        if(this.form.membershipStatus === 'blocked') {
          this.confirmNew('Warning', "Are you sure you want to turn off membership? Customer's membership progress will be lost permanently.",'Yes', 'bg-white text-theme-red', 'No', 'bg-theme-green text-white', true).then(async () => {
            
          }).catch(err => {
              this.form.membershipStatus = 'active'
          })
        }
      },

      /**
       * Update
       */
      async update() {
        // validate business field
        let validate = await this.validateFields(['firstName', 'lastName', 'phone', 'email', 'idNumber']);
        if (!validate) {
          return;
        }
        let data = Helpers.getFormKeyValue(this.form);
        data.dob = this.form.dob ? moment(this.form.dob).format('YYYY-MM-DD') : null;
        data.phone = data.phone?data.phone.toString():null;
        if(this.form.primaryLocationId){
          const loc = (this.vg_locations || []).find(each => each.id === this.form.primaryLocationId);
          data.primaryLocationName = loc?.name || ''
        }
        data.notes = this.form.notes || null;
        const addressEl = document.getElementById('customer-address');
        data.address = (addressEl?.value || this.form.address.value) || null;
        data.city = this.form.city.value || null;
        data.province = this.form.province.value || null;
        data.postalCode = this.form.postalCode.value || null;
        data.businessSlug = this.vg_business.slug;
        data.locationSlug = this.vg_locationSelected.slug
        data.idType = this.form.idType || 'Status Id'
        this.va_spinner(true);
        let res = await UserCustomerApis.update(this.item.id, data);
        if(res.status == 200){
          let res1 = await LoyaltyCustomerApis.updateCustomerTaxExempt(this.item.id, {
            taxIds: this.form.tax || []
          });
          if(res1.status !== 200){
            this.snackbar.add({
              type: 'error',
              text: Helpers.catchErrorMessage(res1.response.data),
              duration: 3000,
            })
            this.va_spinner(false);
            return;
          }else{
            // this.emitter.emit("update-loyalty-user", res.data);
              this.emitter.emit("refresh-loyalty-user-list", true);
            this.clearComponent()
          }
        }
        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      },
      
      /**
       * Adjust points
       */
      async adjustPoints() {
        let validate = await this.validateAdjustmentFormFields(['points']);
        // prevent removing points greater than available
        if(!this.pointAdjustment.isAdditionalPoint && this.pointAdjustment.points.value>this.form.points){
          validate = false
          this.pointAdjustment.points.error_type = 'error'
          this.pointAdjustment.points.error_message = 'Must be less than or equal to '+(this.form.points?this.form.points:0)
        }
        if (!validate) {
          return;
        }
        this.va_spinner(true);
        let res = await LoyaltyPointsAdjustmentApis.adjustPoint(this.item.loyaltyUserId, {
          points: this.pointAdjustment.isAdditionalPoint ?  this.pointAdjustment.points.value : -Math.abs(this.pointAdjustment.points.value),
          notes: "Points updated."
        })
        await this.fetchUserDetailsAndAssign();
        this.va_spinner(false);
        if(res.status == 201){
          this.pointAdjustment = await Helpers.resetFormValue(this.pointAdjustment);
        }
        this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? (res.data.message ? res.data.message : res.data.msg) : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      },

      /**
       * Fetch user details on success update // need for point object
       */
      async fetchUserDetailsAndAssign() {
        let res = await LoyaltyCustomerApis.getUserById(this.item.loyaltyUserId);
        if(res.status  == 200) {
          this.form.points = res.data.points;
          this.emitter.emit("refresh-loyalty-user-list", true);
          // this.emitter.emit("update-loyalty-user", res.data);
          // this.form = await Helpers.assignFormValues(this.form, res.data);
        }
      },
      
      /**
       * Do not allow to add +,-,e
       */
      preventNonNumbers(e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101) {
          return false;
        }
        return true;
      },

      alphaNumericEmail(){
          let x = this.form.email.value.replace(/[^a-z_\-0-9@\.]/gi, '')
          this.form.email.value = x
      },

       /**
       * Open delete confirm modal
       */
      openDeleteConfirmModal() {
        // this.deleteObj = {
        //   modal: true,
        //   obj: this.item,
        // };
      },

      /**
       * Close delete confirm modal
       */
      closeDeleteModal() {
        this.deleteObj = {
          modal: false,
          obj: {},
        };
      },

      /**
       * Delete  
       */
      remove(item){
        this.confirm('Are you sure to delete this?').then(async () => {
          this.va_spinner(true);
          let res = await UserCustomerApis.remove(item.id);
          this.va_spinner(false);
            this.snackbar.add({
            type: 'info',
            text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
            duration: 3000,
          })
          if(res.status == 200 ) {
            this.clearComponent();
            this.emitter.emit("refresh-loyalty-user-list", true);
          }
        })
      },

      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
})

</script>